import { isCwpUserSignedIn } from '../../../../_helpers/isCwpUserSignedIn';
import { SaveButtonProps, SaveButtonVariant } from './SaveButtonProps';
import SavedPageVariant from './variants/SavedPageVariant';
import ComponentVariant from './variants/ComponentVariant';
import {
	getPropsForSavedPageInDesktop,
	getPropsForSavedPageInMobile,
	getPropsForSignedInDesktop,
	getPropsForSignedInMobile,
	getPropsForSignedOutDesktop,
	getPropsForSignedOutMobile,
} from './variants/variantsConfig';
import { useMediaQuery } from '../../../../_helpers/hooks/useMediaQuery';
import { useHydrated } from '../../../../_helpers/hooks/useHydrated';

/**
 * The entry component, which configures and displays the appropriate save button variant,
 * according to whether it is ServerSideRendering, whether the user is logged in, or what device the user is using.
 */
const SaveButton: React.FC<SaveButtonProps> = (props) => {
	const hoverable: boolean = useMediaQuery('(hover: hover)');
	const hydrated = useHydrated();

	if (!hydrated) {
		//Variant for Server Side Rendering
		return <></>;
	} else if (props.variant === SaveButtonVariant.SAVED_PAGE) {
		if (hoverable) {
			//Saved Page variant for desktop
			return <SavedPageVariant {...getPropsForSavedPageInDesktop(props)} />;
		}
		//Saved Page variant for mobile
		return <SavedPageVariant {...getPropsForSavedPageInMobile(props)} />;
	} else if (isCwpUserSignedIn()) {
		if (hoverable) {
			//Component (list & single view) variant for desktop for logged-in user
			return <ComponentVariant {...getPropsForSignedInDesktop(props)} />;
		}
		//Component (list & single view) variant for mobile for logged-in user
		return <ComponentVariant {...getPropsForSignedInMobile(props)} />;
	} else {
		if (hoverable) {
			//Component (list & single view) variant for desktop for not logged-in user
			return <ComponentVariant {...getPropsForSignedOutDesktop(props)} />;
		}
		//Component (list & single view) variant for mobile for not logged-in user
		return <ComponentVariant {...getPropsForSignedOutMobile(props)} />;
	}
};

export default SaveButton;
